import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { SEASONAL_LOGO_APPEARANCE_PERCENT } from '../../env'
import { SeasonalPeriod } from './seasonalPeriods'

export const seasonalAnimations = {
  halloween: [
    'bat-flight',
    'ghost-peek',
    'spider-web',
    'pumpkin-eats-logo',
    'pumpkin-centipede',
    'witch-flight',
    'cat-skull',
    'crow-hop',
    'zombie-tug',
    'potion-drip',
    'moon-howl',
    'coffin-wave',
    'ghost-autumn-parade',
    'ghostbusters-trap',
    'beetlejuice-sandworm',
    'addams-thing-snap',
    'hocus-pocus-spellbook',
    'scream-phone-surprise',
    'it-red-balloon',
    'halloween-mask-peek',
    'sleepy-hollow-horseman',
  ],
  christmas: [
    'snow-fall',
    'santa-flight',
    'gift-bounce',
    'elf-drop',
    'bauble-swing',
    'reindeer-peek',
    'penguin-slide',
    'snowman-stack',
    'stocking-drop',
    'gingerbread-run',
    'grinch-steal',
    'ticket-punch',
    'paint-can-swing',
    'burglar-spider',
    'christmas-lights-overload',
    'elf-paper-chain',
    'grinch-garland-pull',
    'jack-snake-gift',
    'gremlin-snow-multiply',
    'santa-chimney-fall',
    'love-cue-cards',
    'santa-chocolate-tray',
    'christmas-wolf-howl',
  ],
  'new-year': ['firework-burst', 'confetti-pop'],
  easter: ['bunny-walk', 'egg-bounce', 'chick-peek', 'butterfly-loop', 'flower-bloom'],
  valentine: ['heart-float'],
  bastille: ['tricolor-logo'],
} as const satisfies Record<SeasonalPeriod, readonly string[]>

export type SeasonalAnimation = (typeof seasonalAnimations)[SeasonalPeriod][number]

export const seasonalAnimationLoaders: Record<SeasonalAnimation, () => Promise<{ default: string }>> = {
  'bat-flight': () => import('../../img/seasonal/bat-flight.webp'),
  'ghost-peek': () => import('../../img/seasonal/ghost-peek.webp'),
  'spider-web': () => import('../../img/seasonal/spider-web.webp'),
  'pumpkin-eats-logo': () => import('../../img/seasonal/pumpkin-eats-logo.webp'),
  'pumpkin-centipede': () => import('../../img/seasonal/pumpkin-centipede.webp'),
  'witch-flight': () => import('../../img/seasonal/witch-flight.webp'),
  'cat-skull': () => import('../../img/seasonal/cat-skull.webp'),
  'crow-hop': () => import('../../img/seasonal/crow-hop.webp'),
  'zombie-tug': () => import('../../img/seasonal/zombie-tug.webp'),
  'potion-drip': () => import('../../img/seasonal/potion-drip.webp'),
  'moon-howl': () => import('../../img/seasonal/moon-howl.webp'),
  'coffin-wave': () => import('../../img/seasonal/coffin-wave.webp'),
  'ghost-autumn-parade': () => import('../../img/seasonal/ghost-autumn-parade.webp'),
  'ghostbusters-trap': () => import('../../img/seasonal/ghostbusters-trap.webp'),
  'beetlejuice-sandworm': () => import('../../img/seasonal/beetlejuice-sandworm.webp'),
  'addams-thing-snap': () => import('../../img/seasonal/addams-thing-snap.webp'),
  'hocus-pocus-spellbook': () => import('../../img/seasonal/hocus-pocus-spellbook.webp'),
  'scream-phone-surprise': () => import('../../img/seasonal/scream-phone-surprise.webp'),
  'it-red-balloon': () => import('../../img/seasonal/it-red-balloon.webp'),
  'halloween-mask-peek': () => import('../../img/seasonal/halloween-mask-peek.webp'),
  'sleepy-hollow-horseman': () => import('../../img/seasonal/sleepy-hollow-horseman.webp'),
  'snow-fall': () => import('../../img/seasonal/snow-fall.webp'),
  'santa-flight': () => import('../../img/seasonal/santa-flight.webp'),
  'gift-bounce': () => import('../../img/seasonal/gift-bounce.webp'),
  'elf-drop': () => import('../../img/seasonal/elf-drop.webp'),
  'bauble-swing': () => import('../../img/seasonal/bauble-swing.webp'),
  'stocking-drop': () => import('../../img/seasonal/stocking-drop.webp'),
  'penguin-slide': () => import('../../img/seasonal/penguin-slide.webp'),
  'reindeer-peek': () => import('../../img/seasonal/reindeer-peek.webp'),
  'snowman-stack': () => import('../../img/seasonal/snowman-stack.webp'),
  'gingerbread-run': () => import('../../img/seasonal/gingerbread-run.webp'),
  'paint-can-swing': () => import('../../img/seasonal/paint-can-swing.webp'),
  'ticket-punch': () => import('../../img/seasonal/ticket-punch.webp'),
  'grinch-steal': () => import('../../img/seasonal/grinch-steal.webp'),
  'burglar-spider': () => import('../../img/seasonal/burglar-spider.webp'),
  'christmas-lights-overload': () => import('../../img/seasonal/christmas-lights-overload.webp'),
  'elf-paper-chain': () => import('../../img/seasonal/elf-paper-chain.webp'),
  'grinch-garland-pull': () => import('../../img/seasonal/grinch-garland-pull.webp'),
  'jack-snake-gift': () => import('../../img/seasonal/jack-snake-gift.webp'),
  'gremlin-snow-multiply': () => import('../../img/seasonal/gremlin-snow-multiply.webp'),
  'santa-chimney-fall': () => import('../../img/seasonal/santa-chimney-fall.webp'),
  'love-cue-cards': () => import('../../img/seasonal/love-cue-cards.webp'),
  'santa-chocolate-tray': () => import('../../img/seasonal/santa-chocolate-tray.webp'),
  'christmas-wolf-howl': () => import('../../img/seasonal/christmas-wolf-howl.webp'),
  'firework-burst': () => import('../../img/seasonal/firework-burst.webp'),
  'confetti-pop': () => import('../../img/seasonal/confetti-pop.webp'),
  'bunny-walk': () => import('../../img/seasonal/bunny-walk.webp'),
  'egg-bounce': () => import('../../img/seasonal/egg-bounce.webp'),
  'chick-peek': () => import('../../img/seasonal/chick-peek.webp'),
  'butterfly-loop': () => import('../../img/seasonal/butterfly-loop.webp'),
  'flower-bloom': () => import('../../img/seasonal/flower-bloom.webp'),
  'heart-float': () => import('../../img/seasonal/heart-float.webp'),
  'tricolor-logo': () => import('../../img/seasonal/tricolor-logo.webp'),
}

interface Props {
  alt: string
  animation?: SeasonalAnimation
  appearancePercent?: number
  imageHeight?: string
  loop?: boolean
  period: SeasonalPeriod
  src: string
}

const ANIMATED_LOGO_DURATION_MS = 6000

export const rollSeasonalAppearance = (
  percent: number = SEASONAL_LOGO_APPEARANCE_PERCENT,
  random: () => number = Math.random
): boolean => random() * 100 < percent

export const selectRandomSeasonalAnimation = (
  period: SeasonalPeriod,
  random: () => number = Math.random
): SeasonalAnimation | null => {
  const animations = seasonalAnimations[period]
  if (animations.length === 0) return null

  const index = Math.min(Math.floor(random() * animations.length), animations.length - 1)
  return animations[index]
}

const SeasonalLogo: React.FC<Props> = ({
  alt,
  animation,
  appearancePercent = SEASONAL_LOGO_APPEARANCE_PERCENT,
  imageHeight,
  loop = false,
  period,
  src,
}) => {
  const [randomAnimation] = useState(() => selectRandomSeasonalAnimation(period))
  const selectedAnimation = animation ?? randomAnimation
  const [shouldAppear] = useState(() => loop || rollSeasonalAppearance(appearancePercent))
  const [loadedAsset, setLoadedAsset] = useState<{ animation: SeasonalAnimation; source: string } | null>(null)
  const [showAnimatedLogo, setShowAnimatedLogo] = useState(false)
  const [animatedLogoRun, setAnimatedLogoRun] = useState(0)
  const animatedLogoSource = loadedAsset?.animation === selectedAnimation ? loadedAsset.source : undefined

  useEffect(() => {
    if (!selectedAnimation || !shouldAppear) return

    let cancelled = false
    setLoadedAsset(null)

    void seasonalAnimationLoaders[selectedAnimation]().then(({ default: source }) => {
      if (!cancelled) setLoadedAsset({ animation: selectedAnimation, source })
    })

    return () => {
      cancelled = true
    }
  }, [selectedAnimation, shouldAppear])

  useEffect(() => {
    if (!animatedLogoSource || loop) return

    setAnimatedLogoRun((run) => run + 1)
    setShowAnimatedLogo(true)
    const animationTimeout = setTimeout(() => setShowAnimatedLogo(false), ANIMATED_LOGO_DURATION_MS)

    return () => {
      clearTimeout(animationTimeout)
    }
  }, [animatedLogoSource, loop])

  const seasonalImage = !selectedAnimation ? (
    <Box component="img" src={src} alt={alt} />
  ) : animatedLogoSource && loop ? (
    <Box component="img" alt={alt} src={animatedLogoSource} />
  ) : animatedLogoSource && showAnimatedLogo ? (
    <picture key={animatedLogoRun}>
      <source
        data-seasonal-animated-logo
        media="(prefers-reduced-motion: no-preference)"
        srcSet={animatedLogoSource}
        type="image/webp"
      />
      <Box component="img" src={src} alt={alt} />
    </picture>
  ) : loop ? null : (
    <Box component="img" src={src} alt={alt} />
  )

  return (
    <Box
      data-seasonal-animation={selectedAnimation ?? undefined}
      data-seasonal-period={period}
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 0,
        position: 'relative',
        '& picture': {
          display: 'contents',
        },
        '& img': {
          display: 'block',
          height: imageHeight ?? '2.8rem',
        },
      }}
    >
      {seasonalImage}
    </Box>
  )
}

export default SeasonalLogo
